var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.filteredDataGatherings),function(dataGathering,index){return (_vm.filteredDataGatherings.length > 0)?_c('data-gathering-card',{key:index,attrs:{"data-gathering":dataGathering}}):_c('no-results')}),1)}
var staticRenderFns = []

export { render, staticRenderFns }